import axios from 'axios';
import store from '../store';
import { Toast } from 'vant';

let prefix =
  store.getters.userInfo && store.getters.userInfo.url
    ? store.getters.userInfo.url
    : '';
let device_id =
  store.getters.userInfo && store.getters.userInfo.device_id
    ? store.getters.userInfo.device_id
    : undefined;
let rfid_id =
  store.getters.userInfo && store.getters.userInfo.rfid_id
    ? store.getters.userInfo.rfid_id
    : undefined;
const service = axios.create({
  baseURL: `${prefix}/api`,
  timeout: 30000,
});

const errorHandler = ({ response } = {}) => {
  const {
    status,
    data,
    data: { code },
  } = response;
  if (status === 400 || status === 500 || code === 400 || code === 500) {
    Toast(data.message || '服务器内部发生错误，请稍后再试');
  }
  return Promise.reject(data);
};

service.interceptors.request.use(
  ({ headers, params = {}, data = {}, ...rest }) => {
    if (data instanceof FormData) {
      return {
        headers: { ...headers },
        params,
        data,
        ...rest,
      };
    }
    return {
      ...rest,
      params: { device_id, rfid_id: rfid_id || '', ...params },
      data: { device_id, rfid_id: rfid_id || '', ...data },
      headers: { ...headers },
    };
  }
);

service.interceptors.response.use(response => {
  if (response.data.code >= 300) {
    return errorHandler({ response });
  }
  return response.data;
}, errorHandler);

export default service;
